import { render } from "./RouteBreadcrumb.vue?vue&type=template&id=fc43a2dc"
import script from "./RouteBreadcrumb.vue?vue&type=script&lang=js"
export * from "./RouteBreadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\david\\Documents\\Dada\\Omnichannel-Dada\\dashboard-agente\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__